import type { ReactElement } from "react";

import { cn } from "@/lib/utils";

import { signal } from "./signals";

export function SignalWaitDot({
  className,
}: {
  className?: string;
}): ReactElement {
  return (
    <span
      className={cn(
        signal.wait,
        "inline-block size-1.5 shrink-0 rounded-full bg-current",
        className,
      )}
      aria-hidden="true"
    />
  );
}
